
$(document).scroll(function () {
    if (!$('#projectdetail').length) {
        return
    }
    var topScroll = jQuery(window).scrollTop();
    let inner = window.innerHeight;
    if ($('.maintitle').offset().top - topScroll <= inner) {
        $('.maintitle').addClass('animated fadeInUp')
    }
    if ($('.mainlist').offset().top - topScroll <= inner) {
        $('.mainlist').addClass('animation-scale-up')
    }
})


//////////////////
// WEBPACK FOOTER
// ./utils/project-detail.js
// module id = kkD4
// module chunks = 1